/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { w as index$z } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import navigateBack$4 from './cn/index.js';
import navigateBack$5 from './cnStation/index.js';
import navigateBack$7 from './fm/index.js';
import navigateBack$8 from './tm/index.js';
import navigateBack$6 from './tb/index.js';
import navigateBack$9 from './ali1688/index.js';
import navigateBack$1 from './browser/index.js';
import navigateBack$2 from './dingTalk/index.js';
import navigateBack$3 from './dingTalkPC/index.js';
import navigateBack$a from './panguMiniApp/index.js';
import mini from './mini/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';
import '../../common-42e7d8d8.js';
import '../../safe-data-66f20265.js';
import '../../index-ee2c9aee.js';

// api: https://uni-apis.alibaba-inc.com/doc/Navigation/back
var apiConfig = {
    web: {
        browser: navigateBack$1,
        dingTalk: navigateBack$2,
        dingTalkPC: navigateBack$3,
        windvane: {
            // 菜鸟系
            cn: navigateBack$4,
            cnStation: navigateBack$5,
            // 淘系
            tb: navigateBack$6,
            tbLive: navigateBack$6,
            fm: navigateBack$7,
            tm: navigateBack$8,
            ali1688: navigateBack$9,
        },
    },
    // @ts-ignore TODO TS类型处理，mini容器暂时不改动之前的逻辑
    mini: mini,
    panguMiniApp: navigateBack$a,
};
var extendNavigateBack = extend(apiConfig, index$z);
/**
 * 关闭WebView新窗口。一般跟navigateTo成对出现
 * @see API：https://yuque.antfin.com/cn-xt/arch/lwbvd0#4e081fc0
 * @param  {unknown} [data] 关闭时，发送给上个页面的数据
 * @returns {Promise<unknown>} promise调用结果
 * @example 使用案例：
 * import { navigateBack } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * navigateBack()
 *   .then(() => {
 *     console.log('success');
 *   })
 *   .catch((error) => {
 *     console.log(error);
 *   });
 * @author 敬文
 */
var navigateBack = function (data) {
    // 支持2种传参方式：小程序格式(必须有data方法)：{ data: xxxx }, webview格式： xxx
    if (data && Object.prototype.hasOwnProperty.call(data, 'data')) {
        return extendNavigateBack(data);
    }
    return extendNavigateBack({ data: data });
};

export { extendNavigateBack, navigateBack };
